import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "af2c151e-d7be-4303-bf3d-19b21a303cc6",
  publicId: "24",
  name: "Examples of good and bad constructions and workmanship practice",
  difficulty: 2,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, task01],
};

export default lesson;
